import styles from './SetSelector.module.css'
import Select from 'react-select';

// Selettore dell'insieme di apprendimento
export default function SetSelector({sets, set, selectSet, resetPage}) {

    const mapListToOptions = (list) => {
        return list.map((element, i) => { return { value: element.toLowerCase(), label: element }});
    }

return (
    <div className={styles.setSelection}>
        <label className={styles.controlPanelLabel}>Set</label>
        <Select
            className={styles.setSelect}
            value={set} onChange={(e) => {
                selectSet(e);
                resetPage({'set': e.value});
            }}
            options={mapListToOptions(sets)}
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    primary: 'var(--primary-color)',
                    primary75: 'var(--primary-color75)',
                    primary50: 'var(--primary-color50)',
                    primary25: 'var(--primary-color25)',
                    
                },
              })}/>
    </div>
);
}